import { Col, Row, Spin } from "antd";
import AudioPlayer from "components/AudioPlayer";
import IntlMessages from "components/Message/IntlMessages";
import FeatherIcon from "components/Misc/FeatherIcon";
import Font from "components/Misc/Font";
import { useCallback, useState } from "react";

const VulnerableSoundFile = ({ className, url, security, isPlaying, setIsPlaying }) => {
  const key = `vulnerable_sound_${security}_${url.split(/[/\\]/)?.pop()}`;

  const [isReady, setIsReady] = useState(false);
  const [isError, setIsError] = useState(false);
  const [played, setPlayed] = useState(+sessionStorage.getItem(key) ?? 0);

  const onProgress = useCallback(
    (playedSecond, isEnd) => {
      setPlayed(playedSecond);
      sessionStorage.setItem(key, isEnd ? 0 : playedSecond);
    },
    [key]
  );

  const onReady = useCallback(() => setIsReady(true), []);
  const onError = useCallback((e) => {
    setIsReady(true);
    setIsError(true);
  }, []);

  return (
    <Row className={className} gutter={[4, 4]}>
      <Col span={24}>
        <div className="d-flex-main justify-content-start">
          <FeatherIcon icon="volume-1" size={18} color="black" weight={500} />
          <Font className="ms-2" color="black" weight={600}>
            <IntlMessages id="modal.disclaimer.header.risk-profile.audio" />
          </Font>
        </div>
      </Col>
      <Col span={24}>
        <Spin spinning={!isReady}>
          <AudioPlayer
            url={url}
            isPlaying={isPlaying}
            setIsPlaying={setIsPlaying}
            played={played}
            isError={isError}
            onProgress={onProgress}
            onReady={onReady}
            onError={onError}
            skipOnProgressAtFirst
          />
        </Spin>
        {isError && (
          <small className="color-error">
            <IntlMessages id="global.error.header" />
          </small>
        )}
      </Col>
    </Row>
  );
};

export default VulnerableSoundFile;
